module.exports = __webpack_public_path__ + "static/img/telephone.e2e5dd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/Main/telephone.png
// module id = 1155
// module chunks = 18